import { render, staticRenderFns } from "./AssetSubClassification.vue?vue&type=template&id=3270e897&"
import script from "./AssetSubClassification.vue?vue&type=script&lang=js&"
export * from "./AssetSubClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports